/* Perf (cozecats-speed-seo): first gallery image first, the rest afterwards, one by one.
   1) Swiper default preloadImages:true makes every gallery slide (mobile + hidden desktop gallery) download at init,
      competing with the first image. Turn it off (product pages only; this file is only loaded there).
   2) Once the first image is loaded and the DOM is ready, load the remaining images of the VISIBLE gallery in order,
      one at a time, so swiping is instant but nothing competes with the first image. */
(function () {
  try {
    var S = window.MinimogLibs && window.MinimogLibs.Swiper;
    if (S && S.extendDefaults) S.extendDefaults({ preloadImages: false });
  } catch (e) {}

  function visible(el) { return !!(el && el.getClientRects().length); }

  function queue() {
    var galleries = [].slice.call(document.querySelectorAll('media-gallery-mobile, media-gallery')).filter(visible);
    var imgs = [];
    galleries.forEach(function (g) {
      [].forEach.call(g.querySelectorAll('.m-product-media--item img, .m-product-media--slider__images .swiper-slide img'), function (i) {
        if (imgs.indexOf(i) === -1 && !i.closest('[data-cz-first]')) imgs.push(i);
      });
    });
    var k = 0;
    function next() {
      if (k >= imgs.length) return;
      var i = imgs[k++];
      if (i.complete && i.naturalWidth) { next(); return; }
      var done = false;
      function go() { if (done) return; done = true; next(); }
      i.addEventListener('load', go, { once: true });
      i.addEventListener('error', go, { once: true });
      setTimeout(go, 8000);
      i.loading = 'eager';
    }
    next();
  }

  function start() {
    var first = [].slice.call(document.querySelectorAll('[data-cz-first] img')).filter(visible)[0];
    if (!first || (first.complete && first.naturalWidth)) { queue(); return; }
    var started = false;
    function go() { if (started) return; started = true; queue(); }
    first.addEventListener('load', go, { once: true });
    first.addEventListener('error', go, { once: true });
    window.addEventListener('load', go, { once: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
